import { Box, Card, Stack, Typography } from '@mui/material';
import { ReactElement } from 'react';

import { FadeInUpItem } from '@app/components/Company/FadeInUpItem';
import { Organization } from '@app/types/organization';

interface OrganizationPointListProps {
  organization: Organization;
}

export function OrganizationPointList({
  organization,
}: OrganizationPointListProps): ReactElement {
  return (
    <Stack
      bgcolor="white"
      pb={12}
      pt={5}
      px={{
        sm: 1,
        xs: 2.5,
      }}
    >
      <Typography
        maxWidth={1000}
        color="white"
        align="center"
        py={1}
        width="100%"
        mx="auto"
        mt={6}
        borderRadius={50}
        bgcolor="#3287E1"
        sx={{
          fontSize: 'clamp(1.375rem, 1.3068rem + 0.28vw, 1.5rem)',
          fontWeight: 700,
        }}
      >
        この会社を選ぶ理由
      </Typography>

      <Stack mt={8} spacing={5}>
        {organization.customFields?.strengths?.map((item, index) => (
          <FadeInUpItem key={index} delay={0.1 * index}>
            <Card
              elevation={0}
              sx={{
                border: '1px solid #ddd',
                borderRadius: 2,
                maxWidth: 1000,
                mx: 'auto',
                overflow: 'visible',
                p: {
                  sm: 5,
                  xs: 2,
                },
                position: 'relative',
                width: '100%',
              }}
            >
              <Typography
                sx={{
                  bgcolor: '#3287e1',
                  color: 'white',
                  fontSize: {
                    sm: 25,
                    xs: 18,
                  },
                  fontWeight: 700,
                  left: {
                    sm: 25,
                    xs: 15,
                  },
                  position: 'absolute',
                  px: 1,
                  top: {
                    sm: -20,
                    xs: -15,
                  },
                }}
              >
                POINT.{index + 1}
              </Typography>

              <Stack
                sx={{
                  flexDirection: {
                    sm: 'row',
                    xs: 'column',
                  },
                }}
                gap={5}
                py={1}
              >
                <Box width={'100%'}>
                  <Typography variant="h6" fontWeight={700} mb={2}>
                    {item.title}
                  </Typography>
                  <Typography fontSize={16} lineHeight={1.8}>
                    {item.description}
                  </Typography>
                </Box>

                {item.image?.url && (
                  <Box
                    component="img"
                    src={item.image?.url}
                    alt={item.title}
                    sx={{
                      height: 190,
                      objectFit: 'cover',
                      width: { sm: 190, xs: '100%' },
                    }}
                  />
                )}
              </Stack>
            </Card>
          </FadeInUpItem>
        ))}
      </Stack>
    </Stack>
  );
}
